document.addEventListener('DOMContentLoaded', () => {
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.animate(
          [{ opacity: 0, transform: 'translateY(24px)' }, { opacity: 1, transform: 'none' }],
          { duration: 650, fill: 'both', easing: 'cubic-bezier(.2,.8,.2,1)' }
        );
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.story-copy,.about-copy,.quote,.product-card,.collection-card').forEach((element) => observer.observe(element));
  }

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set('sort_by', select.value);
      window.location.assign(nextUrl.toString());
    });
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const variantSelect = section.querySelector('[data-variant-select]');
    const price = section.querySelector('[data-product-price]');
    const inventory = section.querySelector('[data-inventory-note]');
    const addButton = section.querySelector('[data-add-button]');
    const quantity = section.querySelector('input[name="quantity"]');

    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        const available = option.dataset.available === 'true';
        const formattedPrice = option.dataset.price || '';
        if (price) price.textContent = formattedPrice;
        const inStockLabel = section.dataset.inStockLabel || 'In stock · ready to ship';
        const unavailableLabel = section.dataset.unavailableLabel || 'Currently unavailable';
        if (inventory) inventory.innerHTML = available ? '<span></span>' + inStockLabel : unavailableLabel;
        if (addButton) {
          addButton.disabled = !available;
          addButton.textContent = available
            ? (addButton.dataset.addLabel || 'Add to bag') + ' · ' + formattedPrice
            : (addButton.dataset.soldLabel || 'Sold out');
        }
      });
    }

    section.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
    });
    section.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
    });
  });
});
